<template>
  <div>
    <div class="portlet">
      <div class="portlet-head">
        <h3><i class="fas fa-users"></i> Lista pracowników</h3>
        <div>
          <b-button
            v-b-modal.add-worker-modal
            variant="outline-primary"
            @click="showModal(false, 'profile-modal')"
            v-if="readonly === false"
          >
            <i class="fas fa-plus"></i> Dodaj Pracownika
          </b-button>
        </div>
      </div>
      <div class="portlet-body">
        <div class="searchpanel">
          <form @submit.prevent="doSearch">
            <div class="searching searchpanel-item">
              <div class="input-group flex-nowrap">
                <div class="searching-wrapper searchpanel-item">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Szukaj"
                    aria-label="Szukaj"
                    v-model="search"
                  />
                  <span class="searching-icon">
                    <i class="fas fa-search"></i>
                  </span>
                  <span
                    class="searching-clean"
                    v-show="search"
                    @click="cleanSearch"
                  >
                    <i class="fas fa-times"></i>
                  </span>
                </div>
                <div class="input-group-append">
                  <button
                    class="btn btn-sm btn-outline-secondary d-none"
                    type="submit"
                  >
                    Szukaj
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div>
          <b-table
            class="table table-list table-mobilepro"
            ref="employees_table"
            :fields="fields"
            :busy.sync="isBusy"
            :items="getEmployees"
            stacked="lg"
          >
            <template v-slot:head(options)="data">{{ data.label }}</template>
            <template v-slot:table-busy>
              <TableSpiner />
            </template>
            <template v-slot:cell(fullname)="data"
              >{{ data.item.firstname }} {{ data.item.lastname }}</template
            >
            <template v-slot:cell(status)="data">
              <span :class="classBadge(data.value)">{{ data.value }}</span>
            </template>
            <template v-slot:cell(created_at)="data">{{
              data.item.created_at | date
            }}</template>
            <template v-slot:cell(role)="data">
              <b-form-select
                :readonly="readonly || myid == data.item.id"
                :disabled="readonly || myid == data.item.id"
                v-model="data.value"
                :options="avaibleRole"
                size="sm"
                class="form-control"
                @change="changeRole($event, data.item.id)"
              ></b-form-select>
            </template>
            <template v-slot:cell(options)="data">
              <b-dropdown
                no-caret
                right
                variant="light"
                class="btn-rounded"
                v-if="myid != data.item.id"
              >
                <template v-slot:button-content>
                  <i class="fas fa-ellipsis-v"></i>
                </template>
                <b-dropdown-item-button
                  @click="showModal(data.item.id, 'profile-modal')"
                  >Edytuj profil</b-dropdown-item-button
                >
                <b-dropdown-item-button
                  @click="showModal(data.item.id, 'changeemail-modal')"
                  >Zmień e-mail</b-dropdown-item-button
                >
                <b-dropdown-item-button
                  @click="showModal(data.item.id, 'changepassword-modal')"
                  >Zmień hasło</b-dropdown-item-button
                >
                <b-dropdown-item-button
                  @click="changeStatus(data.item.status, data.item.id)"
                >
                  <span
                    v-if="data.item.status === 'disabled'"
                    class="text-success"
                    >Aktywuj konto</span
                  >
                  <span v-if="data.item.status === 'active'" class="text-info"
                    >Deaktywuj konto</span
                  >
                </b-dropdown-item-button>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button
                  class="danger"
                  @click="remove(data.item.id)"
                >
                  <i class="fas fa-trash-alt"></i> Usuń
                </b-dropdown-item-button>
              </b-dropdown>
              <div v-else>
                <span class="badge badge-primary">Your account</span>
              </div>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <ModalUserChangeEmail :user="selected" v-on:onClose="this.handleDeselect" />
    <ModalUserChangePassword
      :user="selected"
      v-on:onClose="this.handleDeselect"
    />
    <ModalEmployeeProfile
      :user="selected"
      v-on:onClose="this.handleDeselect"
      v-on:onSubmit="this.handleAppendItem"
    />
  </div>
</template>

<script>
/* Services */
import EmployeesService from "@/services/employees.service";
import userManager from "@/services/userManager.service";
/* depedencies components */
import TableSpiner from "../components/TableSpiner";
import ModalUserChangeEmail from "../components/userManager/ModalUserChangeEmail";
import ModalUserChangePassword from "../components/userManager/ModalUserChangePassword";
import ModalEmployeeProfile from "../components/ModalEmployeeProfile";
import {formatDateOnly} from "@/services/helpers";

export default {
  name: "TheEmployees",
  components: {
    TableSpiner,
    ModalUserChangeEmail,
    ModalUserChangePassword,
    ModalEmployeeProfile,
  },
  data() {
    return {
      myid: 0,
      readonly: true,
      search: "",
      isBusy: false,
      selected: {},
      items: null,
      fields: [
        { key: "fullname", label: "Imię i Nazwisko" },
        "email",
        { key: "phone", label: "Tel. Kontaktowy" },
        { key: "created_at", label: "Utworzono" },
        { key: "status", label: "Status" },
        { key: "role", label: "Uprawnienia" },
      ],
      avaibleRole: EmployeesService.avaibleRole,
    };
  },
  mounted() {
    //@TODO: this solution breaks the pattern, change it later
    if (this.$store.getters["user/hasAccess"]("employeesModify")) {
      this.fields.push({
        key: "options",
        label: "Opcje",
        class: "text-center",
      });
      this.readonly = false;
    }
    if (this.$store.getters["user/isManagerOrAdmin"] === false) {
       this.fields.splice(4, 1);
    }
    this.myid = this.$store.getters["user/getMyId"];
  },
  filters: {
    date(value) {
      return formatDateOnly(value, "YYYY-MM-DD");
    }
  },
  methods: {
    cleanSearch() {
      this.search = "";
      this.doSearch();
    },
    doSearch() {
      this.items = null;
      this.$refs.employees_table.refresh();
      return false;
    },
    getEmployees() {
      if (this.$_.isNull(this.items) === false) {
        return this.items;
      }
      this.$Progress.start();
      return EmployeesService.search(this.search.trim())
        .then((items) => {
          this.items = items;
          return this.items;
        })
        .catch(() => {
          return [];
        });
    },
    changeRole(newRole, userId) {
      this.$Progress.start();
      userManager.changeRole(userId, newRole);
    },
    changeStatus(currentStatus, userId) {
      let newStatus = currentStatus === "disabled" ? "active" : "disabled";
      this.$Progress.start();
      userManager.changeStatus(userId, newStatus).then(() => {
        let user = this.$_.find(this.items, { id: userId });
        user.status = newStatus;
      });
    },
    remove(userId) {
      this.$bvModal
        .msgBoxConfirm("Do you really want to delete this employee?", {
          title: "Confirm delete employee",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
        })
        .then((result) => {
          if (result !== true) {
            return;
          }
          this.$Progress.start();
          EmployeesService.delete(userId).then(() => {
            let index = this.$refs.employees_table.localItems.findIndex(
              (user) => user.id === userId
            );
            if (~index) this.$refs.employees_table.localItems.splice(index, 1);
          });
        });
    },
    showModal(userId, modalid) {
      if (userId) {
        this.selected = this.$_.find(this.items, { id: userId });
      }
      this.$nextTick(() => {
        this.$bvModal.show(modalid);
      });
    },
    handleDeselect: function () {
      this.selected = {};
    },
    handleAppendItem: function (newUser) {
      this.items.unshift(newUser);
      this.$refs.employees_table.localItems.unshift(newUser);
    },
    classBadge: function (value) {
      return {
        badge: true,
        "badge-success": value === "active",
        "badge-secondary": value !== "active" && value !== "disabled",
        "badge-danger": value === "disabled",
      };
    },
  },
};
</script>
